import React, { useContext, useEffect, useState } from "react";
import "../components/pagination.css";
import {
  FETCH_ALL_AGENTS_PAGE_STRAPI,
  WEB_URL,
  FECTH_ALL_AGENTS_STRAPI,
} from "../api/constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import { WebsiteContext } from "../context/websiteContext";
import Markdown from "react-markdown";
import qs from "qs";
import { BsTelephonePlus, BsWhatsapp } from "react-icons/bs";
import { useMediaQuery } from "react-responsive";
import Pagination from "../components/Pagination/Pagination";
import { shuffle } from "../helper/shuffleArray";

function XRTeamNew() {
  const [agentsPageData, setAgentsPageData] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const { pathname } = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 425 });
  const isTablet = useMediaQuery({ minWidth: 426, maxWidth: 1024 });

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  const { setShowAreas } = useContext(WebsiteContext);

  const fetchAgentsPageDataStrapi = async () => {
    try {
      const response = await axios.get(`${FETCH_ALL_AGENTS_PAGE_STRAPI}`);
      setAgentsPageData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchAllAgents = async (page = 1) => {
    const query = qs.stringify(
      {
        filters: {
          show_profile: true,
        },
        pagination: { page: page, pageSize: 25 },
        populate: ["profile_picture"],
        fields: ["name", "name_slug", "phone_no", "designation", "languages"],
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
    try {
      const response = await axios.get(`${FECTH_ALL_AGENTS_STRAPI}?${query}`);
      setPageCount(response?.data?.meta?.pagination?.pageCount);
      setAllAgents(shuffle(response?.data?.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAgentsPageDataStrapi();
  }, []);

  useEffect(() => {
    setShowAreas(false);
  }, []);

  useEffect(() => {
    fetchAllAgents(page); // Fetch on page load and when page changes
  }, [page]);

  return (
    <>
      <Helmet>
        <link
          rel="alternate"
          hreflang="en-ae"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-us"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-gb"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-sg"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-in"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Xperience Realty | Real Estate Dubai",
            description:
              "Meet our experienced qualified team of the best Dubai real estate agents who cater to all your real estate needs",
            image:
              "https://res.cloudinary.com/dkhns25jh/image/upload/w_1280,f_auto,q_auto/v1722498994/xr_media/o08kmuwgagb0jc1gpe4l.png",
            url: `${WEB_URL}${pathname.slice(1)}`,
          })}
        </script>
      </Helmet>

      <div className="pt-8 pb-4 px-4 container mx-auto md:pt-16">
        {/* Top section heading and description */}
        <div className="flex flex-col gap-4 mb-8">
          <h1 className="font-[optima-lt-pro] xl:mb-4 font-[500] uppercase text-xl xs:text-xl md:text-3xl 2xl:text-4xl">
            {agentsPageData?.top_section_heading}
          </h1>
          <div className="text-black text-sm md:text-base leading-relaxed text-justify prose prose-p:font-[lato] max-w-none prose-p:font-light">
            <Markdown>{agentsPageData?.top_section_description}</Markdown>
          </div>
        </div>

        {/* Agents cards */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {agents.map((person, index) => (
            <div key={index}>
              <AgentCardV2 person={person} />
            </div>
          ))}
        </div> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {allAgents?.map((item, index) => {
            return (
              <Link
                reloadDocument
                draggable="false"
                to={`/agent/${item.name_slug}/`}
                key={index}
                className={`w-full flex flex-col gap-2 cursor-pointer`}
              >
                {/* Image */}
                <div className="w-full xs:w-full h-[450px] xs:h-[500px] xl:h-[550px] 2xl:h-[auto]">
                  <img
                    src={
                      item?.profile_picture?.formats[
                        isMobile ? "large" : isTablet ? "large" : "large"
                      ].url || item?.profile_picture?.url
                    }
                    alt={item?.profile_picture?.alternativeText}
                    className="w-full h-full object-cover object-center"
                    draggable="false"
                  />
                </div>

                {/* Bottom Section - Details */}
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-col gap-1 items-start ">
                    <p className="text-base md:text-xl uppercase text-black font-[optima-lt-pro] line-clamp-1">
                      {item?.name}
                    </p>
                    <p className="text-bhagwa text-[0.6rem] md:text-xs font-[lato] uppercase line-clamp-1">
                      {item?.designation}
                    </p>
                    <p className="text-gray-700 text-[0.8rem] md:text-sm font-[lato] line-clamp-1">
                      {item?.languages}
                    </p>
                  </div>
                  <div>
                    {/* WhatsApp Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        window.open(
                          `https://wa.me/${item?.phone_no}`,
                          "_blank"
                        );
                      }}
                      className="bg-white rounded-full w-10 h-10 flex items-center justify-center transition-transform hover:scale-110"
                    >
                      <BsWhatsapp className="w-4 h-4 xs:w-6 xs:h-6 text-[#25D366]" />
                    </button>
                    {/* Call Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        window.open(`tel:${item?.phone_no}`, "_blank");
                      }}
                      className="bg-white rounded-full w-10 h-10 flex items-center justify-center transition-transform hover:scale-110"
                    >
                      <BsTelephonePlus className="w-4 h-4 xs:w-6 xs:h-6  text-black" />
                    </button>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Pagination */}
        <div className="py-4">
          <Pagination
            page={page}
            pageCount={pageCount}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
          />
        </div>

        {/* Bottom section content */}
        <div className="pt-4">
          <div className="text-black text-sm md:text-base leading-relaxed text-justify prose prose-p:font-[lato] max-w-none prose-p:font-light">
            <Markdown>{agentsPageData?.bottom_section_content}</Markdown>
          </div>
        </div>
      </div>
    </>
  );
}

export default XRTeamNew;
